import { render, staticRenderFns } from "./AddressNodeList.vue?vue&type=template&id=2c38e21c&scoped=true"
import script from "./AddressNodeList.vue?vue&type=script&lang=js"
export * from "./AddressNodeList.vue?vue&type=script&lang=js"
import style0 from "./AddressNodeList.vue?vue&type=style&index=0&id=2c38e21c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38e21c",
  null
  
)

export default component.exports